export default `:host {
  --background: var(--ids-hierarchy-legend-color-background-default);
}

.ids-hierarchy-legend-item {
  display: flex;
  align-items: center;
  margin-inline-end: calc(var(--ids-space-xs) * 4);
  margin-block-end: var(--ids-space-xs);
  position: relative;
}
.ids-hierarchy-legend-item::before {
  border-radius: var(--ids-border-radius-circle);
  content: " ";
  display: block;
  height: calc(var(--ids-space-xs) * 2);
  width: calc(var(--ids-space-xs) * 2);
  margin-inline-end: var(--ids-space-xs);
  background-color: var(--background);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtaGllcmFyY2h5Iiwic291cmNlcyI6WyJpZHMtaGllcmFyY2h5LWxlZ2VuZC1pdGVtLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0EiLCJzb3VyY2VzQ29udGVudCI6WyI6aG9zdCB7XG4gIC0tYmFja2dyb3VuZDogdmFyKC0taWRzLWhpZXJhcmNoeS1sZWdlbmQtY29sb3ItYmFja2dyb3VuZC1kZWZhdWx0KTtcbn1cblxuLmlkcy1oaWVyYXJjaHktbGVnZW5kLWl0ZW0ge1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBtYXJnaW4taW5saW5lLWVuZDogY2FsYyh2YXIoLS1pZHMtc3BhY2UteHMpICogNCk7XG4gIG1hcmdpbi1ibG9jay1lbmQ6IHZhcigtLWlkcy1zcGFjZS14cyk7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcblxuICAmOjpiZWZvcmUge1xuICAgIGJvcmRlci1yYWRpdXM6IHZhcigtLWlkcy1ib3JkZXItcmFkaXVzLWNpcmNsZSk7XG4gICAgY29udGVudDogJyAnO1xuICAgIGRpc3BsYXk6IGJsb2NrO1xuICAgIGhlaWdodDogY2FsYyh2YXIoLS1pZHMtc3BhY2UteHMpICogMik7XG4gICAgd2lkdGg6IGNhbGModmFyKC0taWRzLXNwYWNlLXhzKSAqIDIpO1xuICAgIG1hcmdpbi1pbmxpbmUtZW5kOiB2YXIoLS1pZHMtc3BhY2UteHMpO1xuICAgIGJhY2tncm91bmQtY29sb3I6IHZhcigtLWJhY2tncm91bmQpO1xuICB9XG59XG4iXX0= */`;
